<template>
  <div style="height: 30vh;  margin: auto">
    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px" v-if="enable ===undefined">
      <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">是否启用：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-select
          v-model="startUsing"
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 80%">
          <el-option
            label="是"
            :value="true">
          </el-option>
          <el-option
            label="否"
            :value="false">
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
      <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">大屏名称：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input class="inline-input" size="mini" placeholder="请输入模板名称" style="width: 80%" v-model="platen.name"></el-input>
      </el-col>
    </el-col>
    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
      <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">大屏标题：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input class="inline-input" size="mini" placeholder="请输入模板标题" style="width: 80%" v-model="platen.title"></el-input>
      </el-col>
    </el-col>
    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
      <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">大屏简称：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input class="inline-input" size="mini" placeholder="请输入模板名称" style="width: 80%" v-model="platen.abbreviation"></el-input>
      </el-col>
    </el-col>
    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
      <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">图片：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15" v-if="platen.bgImage==undefined || platen.bgImage==''" >
        <el-upload
          v-model="platen.bgImage"
          :action="uploadUrl"
          class="upload-demo"
          drag
          :accept="'image/*'"
          :before-upload="beforeUpload"
          :on-success="imageChangeSuccess"
          :on-error="imageChangeError"
          :show-file-list="false"
          :headers="token"
          style="margin-bottom: 60px;"
          :auto-upload="true">
          <i class="el-icon-plus" style="line-height:80px;height: 80px;width: 80px;"></i>
        </el-upload>
      </el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15" v-if="platen.bgImage!=undefined && platen.bgImage!=''">
        <div class="upload-div">
          <img class="upload-img"
               :src="$ftpUrl+platen.bgImage">
          <div class="delete-icon">
                        <span @touchstart="imageRemove" @click="imageRemove">
                            <i class="el-icon-delete"></i>
                        </span>
          </div>
        </div>
      </el-col>
    </el-col>
  </div>
</template>

<script>
import {serviceUrl} from "@/utils/request";
import {saveCustomPage, updateCustomPageById} from '@/network/device-custom-page';
import {imgUploadAstrict} from "@/constant/img-upload-astrict";

export default {
  name: "PlatenSettingSave",
  props: ['code','settingValue','enable'],
  data() {
    return {
      platen: {
        title: '',
        name: '',
        abbreviation: '',
        bgImage: '',
        pageUrl: ''
      },
      token: {},
        startUsing:false,
        uploadUrl: window.g.gatewayUrl.slice(0,-1) + serviceUrl.deviceService + '/api/upload'
      }
  },
  inject: ['reload'],
  created() {
    this.token = {Authorization: 'Bearer' + this.$cookies.get('token')};
    if(this.settingValue){
      this.platen=this.settingValue;
    }
  },
  methods:{
    imageChangeError(){
      this.$message.error("文件上传失败!")
    },
    // 文件类型校验
    beforeUpload(file) {
      return imgUploadAstrict(file, this);
    },
    imageChangeSuccess(file){
      this.platen.bgImage=file.data.domain+file.data.url;
      // 重新渲染
      this.$forceUpdate();
    },
    imageRemove(){
      this.platen.bgImage='';
      // 重新渲染
      this.$forceUpdate();
    },
    edit(item){
      console.log(item);
      // platen
    },
    // 保存数据
    preservation(pageUrl,curComponents){
      if(this.check()){
      this.platen.page=pageUrl;
      let deviceCustomLayouts=[];
      curComponents.forEach(item =>{
        let layout={
          component:item.componentsName,
          name:item.name,
          params:item.params,
        };
        deviceCustomLayouts.push(layout);
      });
      let DeviceCustomPageDto={
        deviceCustomPage:this.platen,
        deviceCustomLayouts:deviceCustomLayouts,
        startUsing:this.startUsing,
        code: this.code
      };
      // 新增
      saveCustomPage(DeviceCustomPageDto).then(res =>{
        console.log(res);
        if (res.code === 0) {
          this.reload();
        }
      });
      }
    },
    // 编辑基础信息
    editCustomPage(){
      console.log(this.platen);
      if(this.check()){
        updateCustomPageById(this.platen).then(res =>{
          console.log(res);
          if (res.code === 0) {
            this.$message.success("编辑成功");
            this.reload();
          }else{
            this.$message.error("编辑失败");
          }
        });
      }
    },
    check(){
      if(!this.$stringIsNotNullAndEmpty(this.platen.title)){
        this.$message.error("请填写大屏名称");
        return false;
      }
      if(!this.$stringIsNotNullAndEmpty(this.platen.name)){
        this.$message.error("请填写大屏标识");
        return false;
      }
      if(!this.$stringIsNotNullAndEmpty(this.platen.abbreviation)){
        this.$message.error("请填写大屏简称");
        return false;
      }
      if(!this.platen.bgImage){
        this.$message.error("请上传大屏图片");
        return false;
      }
      return true;
    }
  },
  watch:{
    settingValue(newVal){
      this.settingValue=newVal;
      if(this.settingValue){
        this.platen=this.settingValue
      }
      console.log(this.settingValue);
    }
  }
}
</script>

<style scoped>
  .delete-icon {
    line-height:80px;height: 80px;width: 80px;position:absolute;text-align: center;display:none;
  }
  .upload-img {
    position:absolute;width: 80px;height: 80px;
  }
  .upload-div {
    margin-bottom: 145px;
  }
  .upload-img:hover+.delete-icon{display:block;}
  .delete-icon:hover{display:block;}
</style>
